import { all } from "redux-saga/effects";
import { watchClientAgreementReportSaga } from "./clientAgreement";
import { watchDueDetailsAndDueDetailsBreakupReportsSaga } from "./dueDetailsAndBreakupReport";
import { watchFeeDetailsReportsSaga } from "./feeDetailsReports";
import { watchHeadCountDetailsSaga } from "./headCountDetails";
import { watchCreditNoteDetailsReportsSaga } from "./creditNoteDetailsReports";
import { watchCenterAreaDueDetailsSaga } from "./centerAreaDueDetails";
import { watchInvoiceTallyDetailsSaga } from "./invoiceTallyDetails";
import { watchLatePaymentFeeDetailsSaga } from "./latePaymentFeeDetails";
import { watchDueDetailsReportsSaga } from "./dueDetailsReports";
export default function* rootSagaReports(getState) {
  yield all([watchClientAgreementReportSaga()]);
  yield all([watchFeeDetailsReportsSaga()]);
  yield all([watchHeadCountDetailsSaga()]);
  yield all([watchDueDetailsAndDueDetailsBreakupReportsSaga()]);
  yield all([watchCreditNoteDetailsReportsSaga()]);
  yield all([watchCenterAreaDueDetailsSaga()]);
  yield all([watchInvoiceTallyDetailsSaga()]);
  yield all([watchLatePaymentFeeDetailsSaga()]);
  yield all([watchDueDetailsReportsSaga()]);
}
